import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';

import empty from 'assets/img/empty-state-man.svg';

const styles = {
  container: ({ palette, spacing }) => ({
    maxWidth: 272,
    width: '100%',
    height: 168,
    padding: spacing(3, 5),
    borderRadius: 2,
    border: `solid 2px ${palette.colors.lightGrey}`,
    backgroundColor: palette.common.white,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
  }),
  image: {
    maxWidth: 123,
    width: '100%',
    height: 'auto',
    margin: '0 auto',
  },
  title: ({ palette }) => ({
    color: palette.colors.darkLilac,
  }),
};

const NoData = ({ text = 'No data to display', sx = {} }) => {
  return (
    <Stack justifyContent="space-between" sx={[styles.container, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Box component="img" src={empty} alt="empty" sx={styles.image} />
      <Typography variant="caption" align="center" sx={styles.title}>
        {text}
      </Typography>
    </Stack>
  );
};

NoData.propTypes = {
  text: PropTypes.string,
  sx: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func])),
  ]),
};
export default NoData;
